var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"data-svg-lvl-3":"spread-block-contour","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 514 430"}},[_c('defs'),_c('g',{attrs:{"id":"Контур"}},[_c('path',{staticClass:"lc-c-3",attrs:{"d":"M420.76,86.62H93.1L66.88,112.84V340.73a12,12,0,0,0,12,12H434.61a12,12,0,0,0,12-12V112.46Z"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }